import { ref } from 'vue'
import { globalHelperFunctions } from '../../functions/global-functions'

export function useCommandId() {
  const commandId = ref<string>(globalHelperFunctions.uuid())

  function newCommandId(updateRef = true) {
    const id = globalHelperFunctions.uuid()
    if (updateRef) {
      commandId.value = id
    }
    return id
  }

  return {
    /** A reactive value which represents a commandId. Its value is always a uuid and can be renewed by callind newCommandId from this composable. */
    commandId,
    /** Assigns a new uuid to the commandId ref and returns it. You can use the returned value from the function or the ref value. */
    newCommandId
  }
}
